import { Button, Col, Form, Input, notification, Popconfirm, Row, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { addMenstrualHistoryApi, deleteMenstrualHistoryApi, listOfMenstrualHistoryApi, updateMenstrualHistoryApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
import { apiErrorMessage } from "../../../../../services/ApiError";
export const MenstrualHistory = () => {

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [MenstrualHistoryData, setMenstrualHistoryData] = useState()
    const [editMenstrualHistoryRecord, setEditMenstrualHistoryRecord] = useState()
    const [loading, setLoading] = useState(false)

    const [form] = Form.useForm();

    // get the list of alll available plans 
    const getListOfMenstrualHistory = () => {
        setLoading(true)

        listOfMenstrualHistoryApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // call when user click on edit
    const editMenstrualHistory = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'name': data.type })
        setEditMenstrualHistoryRecord(data);
    }

    useEffect(() => {
        getListOfMenstrualHistory()
    }, []);

    // filter data according to user search input 
    useEffect(() => {
        filterMenstrualHistory(MenstrualHistoryData);
    }, [MenstrualHistoryData]);

    // filter recipe category
    const filterMenstrualHistory = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.type.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of recipe category
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateMenstrualHistoryApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Menstrual History Update successfully",
                    });
                    getListOfMenstrualHistory()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    // delete a menstrual history option (the server refuses ones patients use)
    const deleteMenstrualHistory = (record) => {
        return deleteMenstrualHistoryApi(record.id)
            .then(() => {
                notification.success({
                    message: "Menstrual History deleted successfully",
                });
                // leave edit mode if the deleted one was being edited
                if (editMenstrualHistoryRecord?.id === record.id) {
                    setButtonName("ADD")
                    setEditMenstrualHistoryRecord()
                    form.setFieldsValue({ 'name': '' })
                }
                getListOfMenstrualHistory()
            })
            .catch((err) => {
                notification.error({
                    message: apiErrorMessage(err),
                });
            });
    };

    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "type": values.name,
                "status": true
            }
            addMenstrualHistoryApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'name': '' })
                        notification.success({
                            message: "Menstrual History added successfully",
                        });
                        getListOfMenstrualHistory()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "type": values.name,
                "status": values.status
            }
            updateMenstrualHistoryApi(editMenstrualHistoryRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Menstrual History Update successfully",
                        });
                        getListOfMenstrualHistory()
                        form.setFieldsValue({ 'name': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };
    const columns = [
        {
            title: 'Types',
            dataIndex: 'type',
            key: 'types',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editMenstrualHistory(record) }} className="me-2" />
                    <Popconfirm title="Sure to delete?" onConfirm={() => deleteMenstrualHistory(record)}>
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            type: 'Not Applicable',
            status: true
        },
        {
            id: '2',
            type: 'Regular',
            status: false
        },
        {
            id: '3',
            type: 'Irregular',
            status: true
        },
        {
            id: '4',
            type: 'Menopause',
            status: true
        }
    ];

    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="MenstrualHistory">
            <Row>
                <Col xl={14}>
                    <Form
                        name="addRecipeTypesForm"
                        // className="addRecipeTypes"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row className="addMenstrualHistoryForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Menstrual History!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter Menstrual History" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={8}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2" icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}
                                >
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>

                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    <h6>Total: {displayData.length > 0 ? displayData.length : 0} </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Menstrual History"
                        onChange={(e) => { filterMenstrualHistory(e.target.value); setMenstrualHistoryData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
